<template>
  <div>
    <v-simple-table dense class="elevation-1 px-2 pt-1 remove-espacos-entre-colunas simple-table-indicadores">
      <template v-slot:default>
        <thead>
          <template v-if="dadosTabela.NIVEL_BAIXO">
            <th>Níveis Produtos</th>
            <th v-for="(item, index) in dadosTabela.NIVEL_ELEVADO" :key="index">
              {{ `${Helpers.nomeMeses[item.mes - 1].substring(0, 3)} ${item.ano}` }}
            </th>
          </template>
          <template v-else>
            <th>Níveis Produtos</th>
            <th colspan="13">
              <v-progress-linear
                indeterminate
                rounded
                color="#F5A9A9"
              ></v-progress-linear>
            </th>
          </template>
        </thead>

        <tbody class="width-col">
          <template v-if="dadosTabela.NIVEL_BAIXO">
            <tr v-for="item in Object.keys(dadosTabela)" :key="item">
              <td class="font-weight-bold">{{ map_niveis_servico[item] }}</td>
              <td
                v-for="(item, index) in dadosTabela[item]"
                :key="index"
                @click="abrirDialogDetalhamento(item)"
                class="cursor-pointer"
              >
                R$ {{ formatarValoresBi(item.total_ruptura) }}
              </td>
            </tr>
            <linha-totalizadora
              :itens="dadosTabela"
              @click:coluna="abrirDialogDetalhamento"
            ></linha-totalizadora>
          </template>

          <template v-else>
            <tr v-for="nivel in map_niveis_servico" :key="nivel">
              <td class="font-weight-bold">{{ nivel }}</td>
              <td colspan="13">
                <v-progress-linear
                  indeterminate
                  rounded
                  color="#F5A9A9"
                ></v-progress-linear>
              </td>
            </tr>
            <linha-totalizadora :itens="dadosTabela" />
          </template>
        </tbody>
      </template>
    </v-simple-table>

    <DetalhamentoClickGrid v-model="detalhamento.dialog" :filtros="detalhamento.filtros" />
  </div>
</template>

<script>
import LinhaTotalizadora from "./LinhaTotalizadora.vue";
import formatarValoresBi from "../../../../helpers/formatarValoresBi.js"
import {logout} from "@/helpers";
import api from "@/api/api";
import DetalhamentoClickGrid from "@/components/indicadores/PerdaVendaPorRupturas/Grid/DetalhamentoClickGrid.vue";

export default {
  components: {
    DetalhamentoClickGrid,
    LinhaTotalizadora
  },
  props: {
    filtros: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    dadosTabela: {},
    map_niveis_servico: {
      NIVEL_ELEVADO: 'Nível Elevado',
      NIVEL_ALTO: 'Nível Alto',
      NIVEL_MEDIO: 'Nível Médio',
      NIVEL_BAIXO: 'Nível Baixo',
      NIVEL_ORDINARIO: 'Nível Ordinário',
      SOB_ENCOMENDA: 'Sob Encomenda',
    },
    detalhamento: {
      dialog: false,
      filtros: {}
    },
  }),
  watch: {
    filtros: {
      handler: function () {
        this.buscarDados();
      },
    },
  },
  mounted() {
    this.buscarDados();
  },
  methods: {
    buscarDados() {
      const data = {
        ...this.filtros
      };

      api.post('indicadores/perda-venda-por-ruptura/grid', data)
        .then((response) => {
          this.dadosTabela = response.data.dados;
        })
        .catch(logout);
    },
    formatarValoresBi(n) {
      return formatarValoresBi(n);
    },
    abrirDialogDetalhamento(item) {
      this.detalhamento.dialog = true;
      this.detalhamento.filtros = {
        ...this.filtros,
        ano: item.ano,
        mes: item.mes,
      };

      if (item.nivel_servico && item.nivel_servico.length) {
        this.detalhamento.filtros.nivel_servico = item.nivel_servico;
      }
    },
  }
}
</script>

<style scoped>

</style>
